export const isTooLightYIQ = (hexcolor: string) => {
  var c = hexcolor.substring(1);
  var rgb = parseInt(c, 16); // convert rrggbb to decimal
  var r = (rgb >> 16) & 0xff; // extract red
  var g = (rgb >> 8) & 0xff; // extract green
  var b = (rgb >> 0) & 0xff; // extract blue
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128;
};
